<template>
  <div class="page-container" style="min-height: auto;">
    <div class="page-title-container">
      <h1 class="hero-text">Get tips to upgrade your hiring process</h1>
      <h2 class="secondary-text">
        No fluff. Action takers only and SURPRISES 🎁
      </h2>

      <div class="cta-container">
        <div class="box-shadow">
          <input
            class="input-container input-conatiner-medium"
            placeholder="Enter your email"
            ref="blogMainPageEmail"
            id="blogMainPageEmail"
            name="blogMainPageEmail"
            v-model="blogMainPageEmail"
            @click="select($refs.blogMainPageEmail, blogMainPageEmail)"
            type="text"
            @keyup.enter="goPost(blogMainPageEmail)"
            maxlength="1000"
          />
          <button class="tertiary-button" type="button" @click="subscribe(blogMainPageEmail)">
            Send me tips
          </button>
        </div>
      </div>
    </div>

    <div class="center-items" style="margin-top: 4rem; margin-bottom: 4rem;">
      <!-- Display name of category selected. Default category: "All" -->
      <a class="category-text">{{ categoryName }}</a>
    </div>

    <div>
      <div class="blog-column-left">
        <main class="articles-preview-container">
          <ArticlePreviewItem
            v-for="(a, i) in articlesPaginated"
            :key="`article-${i}`"
            :createdAt="a.meta.createdAt"
            :imageName="a.meta.imageName"
            :name="a.meta.name"
            :path="a.path"
            :category="a.meta.category"
          />
        </main>
        <h2 v-if="articlesPaginated.length === 0">Nothing found.</h2>
      </div>

      <div class="blog-column-right">
        <h2>Categories</h2>
        <div style="margin-bottom: 1rem;">
          <a class="category-text" @click="$router.push({ path: `/blog` })">All Articles</a>
        </div>
        <div style="margin-bottom: 1rem;" :key="`categories-${i}`" v-for="(c, i) in categories">
          <a class="category-text" @click="$router.push({ path: `/blog-${c.path}` })">{{ c.name }}</a>
        </div>
      </div>
    </div>
  </div>

  <div class="pagination-container">
    <button v-if="currentPage !== 0" @click="previous()" class="secondary-button small-button pagination-button">
      <i class="fas fa-arrow-left previous-page-button-icon"></i> Previous
    </button>
    <button v-if="m()" @click="next()" class="secondary-button small-button">
      Next <i class="fas fa-arrow-right next-page-button-icon"></i>
    </button>
  </div>

  <NewsletterCTA />
  <CulDeSac />
</template>

<script>
import ArticlePreviewItem from "@/components/ArticlePreviewItem";
import CulDeSac from "@/components/CulDeSac";
import NewsletterCTA from "@/components/NewsletterCTA";

import blogRouter from "@/blog/blog";
import categories from "@/blog/categories";

export default {
  components: {
    ArticlePreviewItem,
    CulDeSac,
    NewsletterCTA,
  },

  data() {
    return {
      routeCategory: null,
      articlesPerPage: 5,
      currentPage: 0,
      articles: blogRouter,
      categories,
    };
  },

  beforeRouteEnter(to, from, next) {
    next();
    this.routeCategory = to.params.category;
  },

  beforeRouteUpdate(to, from, next) {
    next();
    this.routeCategory = to.params.category;
  },

  created() {
    window.scrollTo(0, 0);
    this.routeCategory = this.$route.params.category;
  },

  computed: {
    articlesPaginated() {
      let p = this.articles;
      if (this.routeCategory == null) {
        return p.slice(this.currentPage * this.articlesPerPage, this.currentPage * this.articlesPerPage + this.articlesPerPage);
      }

      p = this.articles.filter((x) => x.meta.category.path === this.routeCategory);
      return p.slice(this.currentPage * this.articlesPerPage, this.currentPage * this.articlesPerPage + this.articlesPerPage);
    },

    categoryName() {
      if (this.routeCategory == null) {
        return "All Articles";
      }

      const id = Object.keys(this.categories).find((x) => this.categories[x].path === this.routeCategory);
      return this.categories[id].name;
    },
  },

  methods: {
    m() {
      const maxPages = Math.trunc(this.articles.length / this.articlesPerPage);
      return this.currentPage + 1 < maxPages;
    },

    next() {
      this.currentPage++;
      window.scrollTo(0, 0);
    },

    previous() {
      this.currentPage--;
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style></style>
